import styled from 'theme';

export const RequiredNotice = styled.div`
  color: var(--sys-color-error);
`;
